var ChargeBookingStatus;
(function (ChargeBookingStatus) {
    ChargeBookingStatus["Valid"] = "Valid";
    ChargeBookingStatus["Cancelled"] = "Cancelled";
    ChargeBookingStatus["Activated"] = "Activated";
})(ChargeBookingStatus || (ChargeBookingStatus = {}));
var ChargeBookingDateType;
(function (ChargeBookingDateType) {
    ChargeBookingDateType["Customize"] = "Customize";
    ChargeBookingDateType["SameDay"] = "SameDay";
    ChargeBookingDateType["FullDay"] = "FullDay";
})(ChargeBookingDateType || (ChargeBookingDateType = {}));
